import { ArticlesList } from '../../components';
import { withLayout } from '../../Layout/Layout';
import Head from 'next/head';
import React from 'react';

function News() {
  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            'Stay updated with the latest airline news on First-Class.com. Get the scoop on industry trends, innovations, and travel updates from leading carriers'
          }
        />
        <title>Airline News: Stay Updated on Industry Developments</title>
      </Head>
      <ArticlesList subtype="News" type="Airlines" />
    </>
  );
}

export default withLayout(News, true);
